import Certificate from '../models/Certificate';

// Sample certificates data for demonstration
const sampleCertificates = [
  new Certificate(
    '1',
    'EUAS-ISO9001-2023-001',
    'ABC Manufacturing Ltd.',
    '2023-01-15',
    '2026-01-14',
    'Design and manufacture of industrial equipment and machinery for the automotive industry.',
    'active',
    'https://via.placeholder.com/150'
  ),
  new Certificate(
    '2',
    'EUAS-ISO14001-2022-045',
    'Green Solutions Inc.',
    '2022-06-20',
    '2025-06-19',
    'Environmental management systems for waste processing and recycling operations.',
    'active',
    'https://via.placeholder.com/150'
  ),
  new Certificate(
    '3',
    'EUAS-ISO27001-2021-112',
    'SecureData Systems',
    '2021-11-05',
    '2024-11-04',
    'Information security management for cloud-based data storage and processing services.',
    'active',
    'https://via.placeholder.com/150'
  ),
  new Certificate(
    '4',
    'EUAS-ISO45001-2022-078',
    'SafeWork Construction',
    '2022-08-12',
    '2023-08-11',
    'Occupational health and safety management systems for building construction projects.',
    'expired',
    'https://via.placeholder.com/150'
  ),
  new Certificate(
    '5',
    'EUAS-ISO22000-2023-029',
    'Fresh Foods Processing',
    '2023-03-25',
    '2026-03-24',
    'Food safety management systems for processing and packaging of fresh produce.',
    'active',
    'https://via.placeholder.com/150'
  ),
  new Certificate(
    '6',
    'EUAS-ISO13485-2022-091',
    'MedTech Innovations',
    '2022-09-30',
    '2025-09-29',
    'Quality management systems for the design and manufacture of medical devices.',
    'active',
    'https://via.placeholder.com/150'
  ),
  new Certificate(
    '7',
    'EUAS-ISO50001-2021-063',
    'EnergyWise Solutions',
    '2021-07-18',
    '2022-07-17',
    'Energy management systems for commercial building operations and maintenance.',
    'expired',
    'https://via.placeholder.com/150'
  ),
  new Certificate(
    '8',
    'EUAS-ISO20000-2023-017',
    'IT Service Providers',
    '2023-02-10',
    '2026-02-09',
    'IT service management for enterprise-level support and maintenance operations.',
    'active',
    'https://via.placeholder.com/150'
  ),
  new Certificate(
    '9',
    'EUAS-ISO17025-2022-053',
    'Precision Testing Labs',
    '2022-05-15',
    '2025-05-14',
    'Testing and calibration laboratory services for industrial equipment.',
    'suspended',
    'https://via.placeholder.com/150'
  ),
  new Certificate(
    '10',
    'EUAS-ISO9001-2023-042',
    'Quality Manufacturing Co.',
    '2023-04-05',
    '2026-04-04',
    'Quality management systems for the production of consumer electronics.',
    'active',
    'https://via.placeholder.com/150'
  )
];

export default sampleCertificates;
